import React from 'react';
import Tile from '../components/Tile';
import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import { displayRazorpay } from '../services/razorpay';
import { bookTiles } from '../services/booking.db';

export default function Room({ data, backgroundColor }) {
  const [roomData, setRoomData] = React.useState(data);
  const [selectedTiles, setSelectedTiles] = React.useState([]);
  const [loading, setLoading] = React.useState(false);

  const onTileClicked = (rowIndex, colIndex) => {
    if (roomData.tiles[rowIndex][colIndex].type !== 'o') return
    setRoomData(prev => {
      prev.tiles[rowIndex][colIndex].type = prev.tiles[rowIndex][colIndex].type === "o" ? "s" : "o";
      if (prev.tiles[rowIndex][colIndex].type === "s") {
        setSelectedTiles(prev => [...prev, { rowIndex, colIndex }]);
      } else {
        setSelectedTiles(prev => prev.filter(x => !(x.rowIndex === rowIndex && x.colIndex === colIndex)));
      }
      return { ...prev, tiles: [...prev.tiles] };
    });
  }

  const getTileName = (rowIndex, colIndex) => {
    return String.fromCharCode(rowIndex + 65) + colIndex;
  }


const onUnsuccessfulPayment = () => {
  setLoading(false);
}
  const onSuccessfulPayment = () => {
    console.log("payment success-going to update db", roomData.id, selectedTiles)
    // show blocked modal
    bookTiles(roomData.id, selectedTiles)
      .then(res => {
        setSelectedTiles([]);
        setLoading(false);
        alert("Payment Success, seats are booked.");
      })
      .catch(err => {
        console.log(err)
        setSelectedTiles([]);
        setLoading(false);
        alert("Payment Success, but tiles not booked.\nPlease contact admin with your phone number and email.", err);
      });
  }

  const onDonateButtonClicked = (amount) => {
    setLoading(true);
    displayRazorpay(amount, onSuccessfulPayment,onUnsuccessfulPayment)
  }

  const getFontSize = () => {
    if (roomData && roomData.tiles && roomData.tiles[0].length > 50) return '0.5vw';
    if (roomData && roomData.tiles && roomData.tiles[0].length > 30) return '1vw';
    return '2vw';
  }

  const getTotalBookedTiles = (tiles) => {
    let bookedCount = 0;
    tiles.forEach(row => {
      bookedCount = bookedCount + row.filter(cell => cell?.type === 'b').length
    })
    return bookedCount;
  }

  const getMaxWidth = () => {
    console.log(roomData.tiles[0].length)
    if (!roomData || !roomData.tiles) return '400px';

    if (roomData.tiles[0].length > 30) return '90%';
    if (roomData.tiles[0].length > 20) return '800px';

    return '400px';


  }

  return (
    <Stack style={{ alignItems: 'center', margin: 'clamp(5px, 1vw, 50px)' }}>
      <h1>{roomData.name}</h1>
      <table cellSpacing="0" cellPadding="0" style={{
        width: '100%', maxWidth: getMaxWidth(), fontSize: `clamp(5px, ${getFontSize()}, 12px)`,
        fontFamily: `"Roboto", Courier, monospace`,
        border: 'none',
        borderSpacing: 0
      }}>
        <tbody>
          {
            roomData && roomData.tiles && roomData.tiles.map((rows, rowIndex) => {
              return <tr key={rowIndex} style={{ border: 'none' }}>
                {rows.map((col, colIndex) => <td key={colIndex} style={{ border: 'none' }}>
                  {col && <Tile
                    key={col.id}
                    rowIndex={rowIndex}
                    colIndex={colIndex}
                    backgroundColor={backgroundColor}
                    {...col}
                    onClick={() => onTileClicked(rowIndex, colIndex)}
                  />
                  }
                </td>)}
              </tr>
            })
          }
        </tbody>
      </table>
      <Stack style={{ alignItems: 'center' }}>
        <h2>{roomData && roomData.tiles && getTotalBookedTiles(roomData.tiles)} of {roomData.area.total} booked</h2>
        <h2>{selectedTiles.length} tiles selected</h2>
        {selectedTiles && selectedTiles.length > 0 && <h2>Selected tiles are {
          selectedTiles.map(x => getTileName(x.rowIndex, x.colIndex + 1)).join(", ")
        }</h2>
        }
      </Stack>
      <Button disabled={!(selectedTiles && selectedTiles.length > 0)} variant="contained" style={{ maxWidth: '200px' }}
        onClick={() => onDonateButtonClicked(selectedTiles.length * 2000)}>
        {`Donate Rs.${selectedTiles.length * 2000}/-`}
      </Button>
      <Modal
        open={loading}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      ><div style={
        {
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }
      }>
          <CircularProgress />
        </div></Modal>
    </Stack>
  );
}
